exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nc-help-center-container{display:flex;cursor:pointer}.nc-help-center-container .help-center-arrow{position:relative;width:13px}.nc-help-center-container .help-center-arrow:after{content:\"\";position:absolute;left:3px;top:50%;-webkit-transform:translateY(-2px);transform:translateY(-2px);width:0;height:0;border:3px solid transparent;border-top:4px solid #555;transition:color .3s}.helpcenter-dropdown-container{min-width:128px}.helpcenter-dropdown-container .helpcenter-dropdown-item .iconfont{color:#999;font-size:14px;margin-right:8px}", ""]);

// exports
